const { flex } = window;
const {
    React,
    React: { useEffect }
} = flex.lib;
const { adobe } = flex.tracking;

const { ManheimHeader, ManheimFooter, loader } = flex.components;

import { RX } from '../../../constants/rx';
import { ADOBE_CONSTANTS } from '../../../../../shared/js/constants';

import Content from './Content';
import LandingModal from '../LandingModal';
import LandingMessage from '../LandingMessage';

function Landing({ appContext, landing = {} }) {
    useEffect(() => {
        const { orgId, code } = appContext.app;

        flex.trigger(RX.LANDING.GET_PUBLIC_CONTENT_TEMPLATES, orgId, code);

        adobe.sendPageView({ signature: ADOBE_CONSTANTS.FIREBALL_SIGNATURE });
    }, []);

    if (flex.isBusy(RX.LANDING.GET_PUBLIC_CONTENT_TEMPLATES)) {
        return loader;
    }

    const { isModalOpened = false, modalTemplate = {}, messageTemplate = {} } = landing;

    const { content: modalContent } = modalTemplate;
    const { content: messageContent } = messageTemplate;

    return (
        <div className="payoff-landing">
            {isModalOpened && <LandingModal content={modalContent} />}
            <ManheimHeader />
            {messageContent && <LandingMessage content={messageContent} />}
            <Content />
            <ManheimFooter />
        </div>
    );
}

module.exports = Landing;
